import page from '../pages/place/show/place-show.desktop';
import components from './map.components.desktop';
import gallerySliderComponent from '../components/gallery-slider/gallery-slider.desktop';
import MapShowDesktopComponent from '../components/map/show.desktop';
import TableConfigDesktop from '../components/table-config/table-config.desktop';

export const map = {
  components: {
    ...components,
    'gallery-slider': gallerySliderComponent,
    'map-show': MapShowDesktopComponent,
    'table-config': TableConfigDesktop,
  },
  pages: {
    place: {
      show: page,
    },
  },
};
